module.exports = class IdNamePair {
    constructor() {
        this.id     = 0;
        this.name   = '';
    }
};
